import { useParams } from "react-router-dom";
import { ProjectTab } from "../ProjectPage";

type RouteParams = {
  id: string;
  tab: ProjectTab;
};

export const useProjectDetails = () => {
  const { id, tab } = useParams<RouteParams>();
  const numberId = parseInt(id, 10);
  return { activeTab: tab, id: numberId };
};
